import React from 'react';
import { i18n } from 'utils/i18n';
import MODAL, { MODAL_THEMES } from 'constants/modals';
import Modal from 'components/Modal';

const ConvertedPricesModal = () => (
  <Modal
    modalKey={MODAL.CONVERTED_PRICES_MODAL}
    header={i18n('rental_details_about_currency_conversion')}
    theme={MODAL_THEMES.WHITE}
  >
    <p className='modal-themed__copy'>{i18n('converted_rates_modal_copy')}</p>
  </Modal>
);

export default ConvertedPricesModal;
